import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {requestDemoActions} from "./RequestDemoSlice";
import {requestDemoApi} from "../../api";

function* fetchDemoList(action)
{
	try
	{
		const response = yield call(requestDemoApi.gets, action.payload);
		yield put(requestDemoActions.fetchDataSuccess(response))
	}
	catch (error)
	{
		let message = error.message;
		if(error?.response?.data?.message) message = error.response.data.message;
		yield put(requestDemoActions.fetchDataFailed(message));
	}
}

function* handleSearchDebounce(action)
{
	yield put(requestDemoActions.setFilter(action.payload));
}

export default function* requestDemoSaga()
{
	yield takeLatest(requestDemoActions.fetchData.type, fetchDemoList);
	yield debounce(500, requestDemoActions.setFilterWithDebounce.type, handleSearchDebounce)
}